import React from 'react';
import { MutedMicrophone } from './muted-microphone';
import { UnmutedMicrophone } from './unmuted-microphone';
export const Microphone = ({ disabled }) => {
    return (<>
      {disabled && <MutedMicrophone />}
      {!disabled && <UnmutedMicrophone />}
    </>);
};
